<div  [style.height]="height"><canvas #chart ></canvas></div>